var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_13842_114733)","key":0},React.createElement("path",{"d":"M24.875 12C24.875 5.376 19.499 0 12.875 0C6.251 0 0.875 5.376 0.875 12C0.875 17.808 5.003 22.644 10.475 23.76V15.6H8.075V12H10.475V9C10.475 6.684 12.359 4.8 14.675 4.8H17.675V8.4H15.275C14.615 8.4 14.075 8.94 14.075 9.6V12H17.675V15.6H14.075V23.94C20.135 23.34 24.875 18.228 24.875 12Z","fill":"#1877F2"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_13842_114733"},React.createElement("rect",{"width":"24","height":"24","fill":"white","transform":"translate(0.875)"})))]);
}

Facebook.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
